import { useState, type ReactNode } from 'react';

interface StickySortHeadProps {
    label: string;
    align?: 'left' | 'right' | 'center';
    sortable?: boolean;
    active?: boolean;
    dir?: 'asc' | 'desc';
    onSort?: () => void;
    /** Sits beside the label. Used for the List on new brands information icon. */
    trailing?: ReactNode;
}

function SortMarks({ dir, active }: { dir: 'asc' | 'desc'; active: boolean }) {
    const up = active && dir === 'asc' ? 'var(--cpm-brand-purple)' : 'var(--cpm-text-secondary)';
    const down = active && dir === 'desc' ? 'var(--cpm-brand-purple)' : 'var(--cpm-text-secondary)';
    return (
        <svg width="9" height="13" viewBox="0 0 8 12" style={{ flex: 'none', maxWidth: 'none' }}>
            <path d="M4 0.6 L7.2 4.6 L0.8 4.6 Z" fill={up} />
            <path d="M4 11.4 L7.2 7.4 L0.8 7.4 Z" fill={down} />
        </svg>
    );
}

export default function StickySortHead({
    label,
    align = 'left',
    sortable = false,
    active = false,
    dir = 'asc',
    onSort,
    trailing,
}: StickySortHeadProps) {
    const [hover, setHover] = useState(false);
    const justify = align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start';

    return (
        <div
            className="flex items-center"
            style={{
                gap: 6,
                padding: '10px 16px',
                justifyContent: justify,
                background: 'var(--cpm-purple-tint-13)',
                borderBottom: '1.5px solid var(--cpm-border-strong)',
                whiteSpace: 'nowrap',
            }}
        >
            <button
                type="button"
                disabled={!sortable}
                onClick={(e) => {
                    e.stopPropagation();
                    onSort?.();
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                className="inline-flex items-center bg-transparent border-0"
                style={{
                    gap: 5,
                    padding: '2px 0',
                    fontSize: 10.5,
                    fontWeight: 800,
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    color:
                        hover || active ? 'var(--cpm-brand-navy)' : 'var(--cpm-text-primary)',
                    cursor: sortable ? 'pointer' : 'default',
                }}
            >
                {label}
                {sortable ? <SortMarks dir={dir} active={active} /> : null}
            </button>
            {trailing}
        </div>
    );
}
